import { type AiResponse } from '../../types/ai';

type PlaygroundSessionMemoryPanelProps = {
  sessionInfo: AiResponse['session'] | null;
  sessionId: string;
  messagesLength: number;
  hasCustomerOrderHistory: boolean;
};

export const PlaygroundSessionMemoryPanel = ({
  sessionInfo,
  sessionId,
  messagesLength,
  hasCustomerOrderHistory,
}: PlaygroundSessionMemoryPanelProps) => (
  <div className="rounded-xl border border-black/10 bg-white p-5 shadow-sm">
    <h3 className="text-base font-semibold text-brand-blue">Sessionsminne</h3>
    <p className="mt-1 text-xs text-text-grey">
      Agenten sparar senast {sessionInfo?.messageCount ?? messagesLength} meddelanden per session.
    </p>
    <div className="mt-3">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-text-grey">Session ID</p>
      <p className="mt-1 break-all font-mono text-xs text-brand-blue">
        {sessionInfo?.id ?? sessionId}
      </p>
    </div>
    {sessionInfo?.currentOrder ? (
      <div className="mt-4 space-y-2 rounded-md border border-black/10 bg-brand-beige-tint-1 p-3 text-xs text-brand-blue">
        <p className="text-sm font-semibold text-brand-blue">
          Order {sessionInfo.currentOrder.orderNumber ?? 'okänd'}
        </p>
        <p className="text-text-grey">
          Status:{' '}
          <span
            className={sessionInfo.currentOrder.isVerified ? 'text-green-400' : 'text-amber-300'}
          >
            {sessionInfo.currentOrder.isVerified ? 'Verifierad' : 'Ej verifierad'}
          </span>
        </p>
        {sessionInfo.currentOrder.postalCode ? (
          <p className="text-text-grey">Postnummer: {sessionInfo.currentOrder.postalCode}</p>
        ) : null}
      </div>
    ) : (
      <p className="mt-4 text-xs text-text-grey">
        {hasCustomerOrderHistory
          ? 'Ingen specifik order vald ännu. Orderhistorik finns i sessionen.'
          : 'Ingen order kopplad ännu. Ange ordernummer och postnummer i chatten för att hämta orderinformation.'}
      </p>
    )}
  </div>
);
